import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const FeaturedItems = () => {
  const { language } = useLanguage();

  const translations = {
    en: {
      title: 'Our Specialties',
      subtitle: 'Fresh ingredients, authentic recipes, unforgettable flavors'
    },
    fr: {
      title: 'Nos Spécialités',
      subtitle: 'Ingrédients frais, recettes authentiques, saveurs inoubliables'
    }
  };

  const t = translations[language];

  const photos = [
    {
      src: '/images/pastrami.jpg',
      alt: 'The Reuben Sandwich',
      span: 'lg:col-span-2 lg:row-span-2'
    },
    {
      src: 'https://customer-assets.emergentagent.com/job_sids-sandwich-spot/artifacts/05fo6ity_WhatsApp%20Image%202025-12-28%20at%205.23.17%20PM.jpeg',
      alt: 'Philly Cheesesteak',
      span: ''
    },
    {
      src: 'https://customer-assets.emergentagent.com/job_sids-sandwich-spot/artifacts/w3cq0kuc_WhatsApp%20Image%202025-12-28%20at%205.23.18%20PM%20%281%29.jpeg',
      alt: 'BBQ Ribs with Mac and Cheese',
      span: ''
    },
    {
      src: 'https://customer-assets.emergentagent.com/job_sids-sandwich-spot/artifacts/gav4nkel_WhatsApp%20Image%202025-12-28%20at%205.23.18%20PM%20%282%29.jpeg',
      alt: 'Breakfast Sandwiches',
      span: ''
    },
    {
      src: 'https://customer-assets.emergentagent.com/job_sids-sandwich-spot/artifacts/bly8q3zb_WhatsApp%20Image%202025-12-28%20at%205.23.18%20PM.jpeg',
      alt: 'Breakfast Sandwich with Chips',
      span: ''
    },
    {
      src: 'https://customer-assets.emergentagent.com/job_sids-sandwich-spot/artifacts/49adj4xp_WhatsApp%20Image%202025-12-28%20at%205.23.20%20PM%20%283%29.jpeg',
      alt: 'Rice Krispie Treats',
      span: ''
    },
    {
      src: 'https://customer-assets.emergentagent.com/job_sids-sandwich-spot/artifacts/9r7e9824_WhatsApp%20Image%202025-12-28%20at%205.23.22%20PM%20%281%29.jpeg',
      alt: 'The Royal BEC',
      span: ''
    },
    {
      src: 'https://customer-assets.emergentagent.com/job_sids-sandwich-spot/artifacts/n258z89r_WhatsApp%20Image%202025-12-28%20at%205.23.22%20PM%20%282%29.jpeg',
      alt: 'Philly Cheesesteak Special',
      span: ''
    },
    {
      src: 'https://customer-assets.emergentagent.com/job_sids-sandwich-spot/artifacts/oqtlcq58_WhatsApp%20Image%202025-12-28%20at%205.23.22%20PM.jpeg',
      alt: 'Batman & Robin BBQ Chicken',
      span: ''
    },
    {
      src: 'https://customer-assets.emergentagent.com/job_sids-sandwich-spot/artifacts/60xm6aqm_WhatsApp%20Image%202025-12-28%20at%205.23.23%20PM.jpeg',
      alt: 'Philly Cheesesteak on the Go',
      span: ''
    },
    {
      src: 'https://customer-assets.emergentagent.com/job_sids-sandwich-spot/artifacts/rtlog8qq_WhatsApp%20Image%202025-12-28%20at%205.23.21%20PM%20%283%29.jpeg',
      alt: 'Mac and Cheese',
      span: ''
    },
    {
      src: 'https://customer-assets.emergentagent.com/job_sids-sandwich-spot/artifacts/krl3sgre_WhatsApp%20Image%202025-12-28%20at%205.23.21%20PM.jpeg',
      alt: 'Oatmeal Raisin Cookies',
      span: ''
    },
    {
      src: 'https://customer-assets.emergentagent.com/job_sids-sandwich-spot/artifacts/siapch6m_WhatsApp%20Image%202025-12-28%20at%205.23.23%20PM%20%281%29.jpeg',
      alt: 'Preparing the Philly',
      span: 'lg:col-span-2'
    },
    {
      src: 'https://customer-assets.emergentagent.com/job_sids-sandwich-spot/artifacts/bzc6i2br_WhatsApp%20Image%202025-12-28%20at%205.23.23%20PM%20%282%29.jpeg',
      alt: 'Cooking on the Griddle',
      span: ''
    },
    {
      src: 'https://customer-assets.emergentagent.com/job_sids-sandwich-spot/artifacts/7uts2209_WhatsApp%20Image%202025-12-28%20at%205.23.24%20PM.jpeg',
      alt: 'Smoked Salmon Bagel',
      span: ''
    },
    {
      src: 'https://customer-assets.emergentagent.com/job_sids-sandwich-spot/artifacts/liczxzlw_WhatsApp%20Image%202025-12-28%20at%205.23.20%20PM.jpeg',
      alt: 'Fresh Fries',
      span: ''
    },
    {
      src: 'https://customer-assets.emergentagent.com/job_sids-sandwich-spot/artifacts/6nomyugb_WhatsApp%20Image%202025-12-28%20at%205.23.21%20PM%20%281%29.jpeg',
      alt: 'Chocolate Brownies',
      span: ''
    },
    {
      src: 'https://customer-assets.emergentagent.com/job_sids-sandwich-spot/artifacts/unoylgqa_WhatsApp%20Image%202025-12-28%20at%205.23.21%20PM%20%282%29.jpeg',
      alt: 'Grilled Cheese Sandwich',
      span: ''
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-[#0a1929] to-[#0f1f2e]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-[#c9a961] mb-4">
            {t.title}
          </h2>
          <p className="text-lg text-white/70 max-w-2xl mx-auto">
            {t.subtitle}
          </p>
        </div>

        {/* Photo Grid - Masonry Style */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 auto-rows-[250px]">
          {photos.map((photo, index) => (
            <div
              key={index}
              className={`group relative overflow-hidden rounded-lg shadow-xl hover:shadow-2xl transition-all duration-300 ${photo.span}`}
            >
              <img
                src={photo.src}
                alt={photo.alt}
                className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-500"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturedItems;
